module.exports = __webpack_public_path__ + "img/hx-zyclyq.362d7023.svg";